import React, {useEffect, useRef, useState} from 'react';
import MaterialTable from 'material-table';
import { NavLink } from 'react-router-dom';
import { TablePagination } from '@material-ui/core';
import Cookies from 'js-cookie';
import CircularProgress from '@material-ui/core/CircularProgress';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes} from '@fortawesome/free-solid-svg-icons';
import { clearCookie } from '../../functions/Auth';
import { useHistory } from 'react-router-dom';
import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';

import API_PATH from "../../constants/config.json";
import TableIcons from '../TableIcons';
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

let searchTerm = "";

const Stations = (props) =>{
    const {  needToReload } = props;

    let history = useHistory();
    const [stationList, setStationList] = React.useState([]);
    const [pagination, setPagnation] = React.useState({ selectedPage: 1 });
    const [totalItems, setTotalItems] = React.useState(0);
    const [userAccess, setUserAccess] = React.useState(true);
    const [getLoader,setLoaderDisable] = React.useState(false);
    const [checked,setChecked] = React.useState(false);
    const [hover, setHower] = React.useState(false);
    const [getSearchTerm, setSearchTerm] = React.useState("");
    const refContainer = useRef('');

    const tableRef = useRef();
    let today = new Date();
    today.setDate(today.getDate()-14);
    const enteriesPerPage = 25;
    let values = {
        "pageNo": pagination.selectedPage,
        "entriesPerPage": enteriesPerPage,
    }

    useEffect(
        () => {
            if(needToReload) {
                if(searchTerm !== "")
                    getStationsAPI(1, searchTerm, true);
                else 
                    getStationsAPI();
                setChecked(false)
                clearText();
            }
        }, [needToReload]
    )

    const getStationsAPI = (page = 1, search = "", enable = false) => { 
        setLoaderDisable(true);
        let enableV = search !== "" || searchTerm !== "" ? true : enable;
        try {
          axios({
            method: 'post',
            data: {
              pageNo: page,
              entriesPerPage: enteriesPerPage,
              searchEnable: enableV,
              searchValue: search !== "" ? search : searchTerm,
            },
            headers: {
              'payload': Cookies.get('payload'),
              'agencyid': sessionStorage.getItem('agency_id')
            },
            url: API_URL + API_PATH.getAllStationsAPIv2,
          })
            .then(async function (response) {
              if (response.status && response.status == '200') {
                let rows = response.data.data.rows;
                rows.forEach( (row, ind) => {
                    let tmpdt = new Date(row.created_date);
                    if(tmpdt.getTime() >= today.getTime()) {
                        rows[ind].new = true;
                    } else {
                        rows[ind].new = false;
                    }
                });
                setStationList(rows);
                setTotalItems(response.data.data.count);
                setLoaderDisable(false);
                setChecked(true)
              } else {
                setLoaderDisable(false);
                setStationList([]);
              }
    
            })
            .catch(async function (error) {
              if (error.response) {
                if (error.response.status && error.response.status == '401') {
                  if (Cookies.get('email')) {
                    clearCookie('email');
                    clearCookie('payload');
                    clearCookie('idToken');
                    clearCookie('organization');
                    clearCookie('atexpiry');
                  }
                  history.push('/');
                } else if (error.response.data && error.response.data.status && error.response.data.status == 403) {
                  setUserAccess(false);
                  setLoaderDisable(false);
                  setStationList([]);
                } else {
                  setLoaderDisable(false);
                  setStationList([]);
                }
              } else {
                setLoaderDisable(false);
                setStationList([]);
              }
    
            })
        } catch (error) {
          console.error(error);
        }
    }

    const handleSelected = (e, selectedPage) => {
        values.pageNo = selectedPage + 1;
        let page = values.pageNo
        setPagnation({ selectedPage: selectedPage + 1 })
        getStationsAPI(page);
    }

    const kekPressSearch = (e) => {    
        if(e.key === 'Enter'){
          e.preventDefault();
          onSearch();
        }    
    }

    const searchField = (e) => {
        setHower(true)    
        searchTerm = e.target.value;   
        getStationsAPI(1, e.target.value, true)
        setPagnation({ selectedPage: 1 })    
    }

    const onSearch = () => {   
        if(searchTerm == ''){      
            return;
        }
        getStationsAPI(1, searchTerm, true)
        setPagnation({ selectedPage: 1 })
    }

    const clearText = () => {
        refContainer.current.reset();
        searchTerm = "";
        getStationsAPI(1, "", false);
        setPagnation({ selectedPage: 1 })
    }
   
    return(
        <React.Fragment>  
            <div className="table-top">
                <h3>Data</h3>
                <form ref={refContainer} noValidate autoComplete="off">
                    <TextField
                    id="input-with-icon-textfield"
                    placeholder="Search"
                    onChange={(e) => searchField(e)}
                    onKeyPress={(e) => kekPressSearch(e)}
                    InputProps={{
                        startAdornment: (
                        <InputAdornment position="start" onClick={onSearch}>
                            <SearchIcon style={{ cursor: 'pointer' }} />
                        </InputAdornment>
                        ),
                        endAdornment: (
                        <InputAdornment position="end">
                            {hover && <FontAwesomeIcon icon={faTimes} onClick={clearText} />}
                        </InputAdornment>
                        ),
                    }}

                    />      
                    
                </form>
            </div>   
            <div className={props.scrolled ? "table-container scrolled-el" : "table-container"} onScroll={() => props.handleScroll(tableRef)} ref={tableRef}>
                <MaterialTable
                    icons={TableIcons}
                    title=""
                    className={'station-table'}
                    columns={[
                       
                    { title: 'Station ID', field: 'client_station_id', width: '200px',
                        render: rowData => 
                        <NavLink to="#" onClick={()=> props.handleStationDetails(rowData.station_id, rowData.status)}>
                            {rowData.client_station_id}
                            
                        </NavLink> 
                    },
                    { title: 'Station name', field: 'display_name', width: '480px' },
                    { title: 'Type', field: 'station_type_name', width: '112px', },
                    { title: 'Privacy', field: 'station_privacy', width: '96px', 
                    render: rowData =>
                    <label className={rowData.station_privacy === 1 ? "active-lbl-st" : "disabled-lbl-st"}>{rowData.station_privacy===1?"Public":"Private"}</label>
                    },
                    { title: 'Status', field: 'station_provacy', width: '96px', 
                        render: rowData =>
                        <label className={rowData.status === 'active' ? "active-lbl-st" : "disabled-lbl-st"}>{rowData.status}</label>
                    },
                    { title: 'Actions', field: '', width: '80px', cellStyle: { textAlign: 'center' },
                        render: rowData =>{
                            if(rowData.delete_flag){
                                return <img className="pointer" src={require('../../assets/icons/Dots - Vertical.png')} onClick={(e) => props.handleShowActions(e,rowData.station_id,  rowData.station_type_name)}/> 
                            }
                            else{
                                return ""
                            }
                                
                            
                        }
                        
                        
                        
                    },
                    ]}
                    data={stationList ? stationList : []}
                    totalCount={totalItems}
                    options={{
                        filtering: false,
                        sorting: false,
                        // paging: true,
                        paging: totalItems > 25 ? true : false,
                        pageSize: enteriesPerPage,
                        pageSizeOptions: [0],
                        search:false,
                        emptyRowsWhenPaging: false,
                        draggable: false
                    }}
                    components={
                        userAccess == true ?
                        getLoader == false?
                        {
                            Pagination: props => (
                                <TablePagination
                                {...props}
                                count={totalItems}
                                page={pagination.selectedPage - 1}
                                onChangePage={handleSelected}
                                rowsPerPage={enteriesPerPage}
                                />
                            ),
                            }
                            :
                            {
                                Pagination: props => (
                                <TablePagination
                                    {...props}
                                    count={totalItems}
                                    page={pagination.selectedPage - 1}
                                    onChangePage={handleSelected}
                                    rowsPerPage={enteriesPerPage}
                                    className={'station-pagination'}
                                    style={{height:'35px !important'}}
                                />
                                ),
                                Body: (props) => (
                                <tbody><tr style={{ height: '49px' }}><td colspan="5" style={{ width: '100%', paddingTop: '0px', paddingBottom: '0px', textAlign: 'center' }}><span style={{ color: '#CC0000', fontWeight: '600' }}><CircularProgress/></span> </td></tr></tbody>
                                )
                            }
                        : {
                            Pagination: props => (
                                <TablePagination
                                {...props}
                                count={totalItems}
                                page={pagination.selectedPage - 1}
                                onChangePage={handleSelected}
                                rowsPerPage={enteriesPerPage}
                                className={'station-pagination'}
                                style={{height:'35px !important'}}
                                />
                            ),
                            Body: (props) => (
                                <tbody><tr style={{ height: '49px' }}><td colspan="5" style={{ paddingTop: '0px', paddingBottom: '0px', textAlign: 'center' }}><span style={{ color: '#CC0000', fontWeight: '600' }}><FontAwesomeIcon icon={faTimes} /> Access Forbidden</span> </td></tr></tbody>
                            )
                        }
                    }
                />
            </div>
        </React.Fragment>
    );
}
export default Stations;